const CheckoutUtils = {
  buildURL: (id, slug) => `/${id}/${slug}`,
};

export default CheckoutUtils;
